export const ASSIGNMENT_STATUS_TYPE = {
  EXPIRED: 'Overdue', // 逾期
  PROCESSING: 'Process', // 處理中
  CHECKING: 'End', // 驗收中
  FINISHED: 'Close', // 結案
  CANCEL: 'Back', // 取消
  UNCONFIRMED: '', // 未確認
};

export const GLOBAL_STATUS_TYPE = {
  FAILED: 'Failed',
  WARNING: 'Warning',
  SUCCESS: 'Success',
  UNREAD: 'Unread',
  READ: 'Read',
};

export const SELECT_TYPE = {
  ALL: 'all',
  PART: 'part',
  NONE: 'none',
};

export const TIMEZONE_INFO = {
  '+00:00': 'Etc/GMT',
  '+01:00': 'Etc/GMT-1',
  '+02:00': 'Etc/GMT-2',
  '+03:00': 'Etc/GMT-3',
  '+03:30': 'Asia/Tehran',
  '+04:00': 'Etc/GMT-4',
  '+04:30': 'Asia/Kabul',
  '+05:00': 'Etc/GMT-5',
  '+05:30': 'Asia/Calcutta',
  '+05:45': 'Asia/Kathmandu',
  '+06:00': 'Etc/GMT-6',
  '+07:00': 'Etc/GMT-7',
  '+08:00': 'Etc/GMT-8',
  '+08:45': 'Australia/Eucla',
  '+09:00': 'Etc/GMT-9',
  '+09:30': 'Australia/North',
  '+10:00': 'Etc/GMT-10',
  '+11:00': 'Etc/GMT-11',
  '+12:00': 'Etc/GMT-12',
  '+13:00': 'Etc/GMT-13',
  '+14:00': 'Etc/GMT-14',
  '-01:00': 'Etc/GMT+1',
  '-02:00': 'Etc/GMT+2',
  '-03:00': 'Etc/GMT+3',
  '-04:00': 'Etc/GMT+4',
  '-05:00': 'Etc/GMT+5',
  '-06:00': 'Etc/GMT+6',
  '-07:00': 'Etc/GMT+7',
  '-08:00': 'Etc/GMT+8',
  '-09:00': 'Etc/GMT+9',
  '-10:00': 'Etc/GMT+10',
  '-11:00': 'Etc/GMT+11',
  '-12:00': 'Etc/GMT+12',
};

export const UPLOAD_FILE_LIMITATION =
  'doc、docx、ppt、pptx、xls、xlsx、txt、rtf、pdf、zip、7z、rar、jpg、jpeg、gif、png、bmp';



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/constant/index.js
 **/